module.exports = new __parcel__URL__("avatar.6d85bfd3.png").toString();